import cx from 'classnames'

import { addComma } from '@libs/utils'
import { ProgressBar } from '@components/ProgressBar'
import { CategorySectionProps } from './interface'

export function CategorySection({
  data,
  maxValue,
  topThree,
}: CategorySectionProps) {
  return (
    <div>
      <div className='font-sarabun text-[24px] font-sarabun font-bold text-secondary'>
        สัดส่วนงานเขียนตามหมวดหมู่
      </div>
      <div className='pt-[15px] text-[14px]'>
        {data.countByCategory.map((item, index) => (
          <div
            key={index}
            className='grid grid-cols-[200px_80px_1fr] font-sarabun items-center py-[5px]'
          >
            <div className='text-secondary'>{item.name}</div>
            <div className={cx('text-right', {})}>
              {addComma(item.count, 0)}
            </div>
            <ProgressBar
              className='bg-transparent ml-[20px]'
              progressBarClassName={cx('rounded-[40px]', {
                'bg-secondary-50': !topThree.some(
                  element => element.name === item.name
                ),
                'bg-primary': topThree.some(
                  element => element.name === item.name
                ),
              })}
              value={item.count}
              max={maxValue}
            />
          </div>
        ))}
      </div>
      <hr className='border border-gray h-[1px] mt-[30px] w-full' />
    </div>
  )
}
